/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'search-mobilier': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M8 0a8 8 0 016.32 12.905l5.387 5.388-1.414 1.414-5.388-5.386A8 8 0 118 0zm0 2a6 6 0 100 12A6 6 0 008 2z" _fill="#7E8994" fill-rule="evenodd"/>'
  }
})
